import { Users, UserPlus, FileSpreadsheet, History } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LeadForm } from "./leads/LeadForm";
import { LeadTable } from "./leads/LeadTable";
import { ImportJobsList } from "./leads/ImportJobsList";
import { SequenceBuilder } from "../sequences/SequenceBuilder";
import type { NewsletterLead, LeadImportJob } from "./leads/types";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const LeadsTab = () => {
  const { data: leads, isLoading, refetch } = useQuery({
    queryKey: ['newsletter-leads'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('newsletter_leads')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching leads:', error);
        return [];
      }
      return data as NewsletterLead[];
    },
  });

  const { data: importJobs } = useQuery({
    queryKey: ['lead-import-jobs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('lead_import_jobs')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(5);
      
      if (error) {
        console.error('Error fetching import jobs:', error);
        return [];
      }
      return data as LeadImportJob[];
    },
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Users className="h-5 w-5 text-primary" />
        <h2 className="text-2xl font-bold tracking-tight">Leads Management</h2>
      </div>
      <p className="text-muted-foreground">
        Manage your newsletter subscribers and lead data.
      </p>
      
      <Separator />
      
      <Tabs defaultValue="all" className="space-y-4">
        <TabsList>
          <TabsTrigger value="all">All Leads</TabsTrigger>
          <TabsTrigger value="add">Add Lead</TabsTrigger>
          <TabsTrigger value="import">Import</TabsTrigger>
          <TabsTrigger value="sequences">Sequences</TabsTrigger>
        </TabsList>

        <TabsContent value="all" className="space-y-4">
          <LeadTable leads={leads} isLoading={isLoading} />
        </TabsContent>

        <TabsContent value="add" className="space-y-4">
          <LeadForm onSuccess={refetch} />
        </TabsContent>

        <TabsContent value="import" className="space-y-4">
          <ImportJobsList importJobs={importJobs} />
        </TabsContent>

        <TabsContent value="sequences" className="space-y-4">
          <SequenceBuilder />
        </TabsContent>
      </Tabs>
    </div>
  );
};